import { Component, input } from '@angular/core';
import { CardComponent } from '../../../../components/card/card.component';
import { MetricCardComponent } from '../../../../components/metric-card/metric-card.component';
import { GraphComponent } from '../../../../components/graph/graph.component';
import { UIGraph } from '../graphs/graph.interface';
import { MetricsGraphTitleComponent } from './metrics-graph-title/metrics-graph-title.component';
import { getRangeString } from '../../../../utils/dayjs/dayjs';
import { MetricFilter } from '../../../../types/Metrics';

@Component({
  selector: 'app-metrics-graph-group',
  imports: [CardComponent, MetricCardComponent, GraphComponent, MetricsGraphTitleComponent],
  templateUrl: './metrics-graph-group.component.html',
  styleUrl: './metrics-graph-group.component.css',
})
export class MetricsGraphGroupComponent {
  public graphs = input.required<UIGraph[]>();
  public filters = input.required<MetricFilter[]>();

  protected calculateDate() {
    const range = this.filters().find((f) => f.type === 'range');
    // We only support one range
    if (!range) return '';
    return getRangeString(range.selected.min.toString(), range.selected.max.toString());
  }
}
